'use strict'

import Vue from 'vue'
import { bus } from './common/bus'

const App = () => import('./App.vue')
bus.bus = new Vue({
  render: h => h(App)
})
bus.bus.$mount('#app')
